import type { OnboardingStepId, OrganizationOnboardingSteps } from "@/hooks/use-onboarding";
import { createContext } from "react";

export const OnboardingContext = createContext<{
    steps: OrganizationOnboardingSteps;
    complete: (step: OnboardingStepId) => void;
} | null>(null);
